module.exports = __webpack_public_path__ + "static/media/049-thief.2279be10.svg";